import React from "react";

import { BillingPanel } from "../../../components/admin/u1/billing/BillingPanel";
import { OwnerCard } from "../../../components/common/static/u1/OwnerCard";
import { ResearcherCard } from "../../../components/common/static/u1/ResearcherCard";
import "../../../components/common/u1/tokens.css";

/* u1 Billing. Visual uplift only. The screen's data handling is transcribed in BillingPanel; the rail reuses the static cards the other dashboard screens... */
export default function Billing() {
  return (
    <div className="u1-root grid grid-cols-1 items-start gap-[22px] py-6 lg:grid-cols-[minmax(0,1fr)_340px]">
      <BillingPanel />

      <aside className="flex min-w-0 flex-col gap-4">
        <OwnerCard />
        <ResearcherCard />
      </aside>
    </div>
  );
}
